import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from '../Box/Box.js';

const StyledBox = styled(Box).withConfig({
  componentId: "sg1390__sc-133b4c2-0"
})(["display:flex;flex-direction:column;max-width:", ";outline:0;pointer-events:auto;@supports (margin-bottom:env(safe-area-inset-bottom)){margin-bottom:env(safe-area-inset-bottom);}"], props => ({
  sm: '300px',
  md: '500px',
  lg: '800px',
  xl: '1140px'
})[props.$size || 'md']);
const ModalContent = _ref => {
  let {
    children,
    className,
    size
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledBox, {
    $size: size,
    border: "none",
    className: className,
    noMargin: true,
    padding: "none",
    shadow: "modal"
  }, children);
};
ModalContent.displayName = 'ModalContent';
ModalContent.propTypes = {
  /**
   * Modal content.
   */
  children: PropTypes.node,
  className: PropTypes.string
};

export { ModalContent };
